import { Injectable } from '@angular/core';
import { NzMessageRef, NzMessageService } from 'ng-zorro-antd/message';

@Injectable({
    providedIn: 'root'
})
export class MessageService {

    messageRef:NzMessageRef;

    constructor(
        private nzMessageService:NzMessageService
    ) { }

    public info(content, options?){
        this._createMessage('info', content, options);
    }

    public success(content, options?){
        this._createMessage('success', content, options);
    }

    public error(content, options?){
        this._createMessage('error', content, options);
    }

    public warning(content, options?){
        this._createMessage('warning', content, options);
    }

    public loading(content, options?){
        this._createMessage('loading', content, options);
    }

    private _createMessage(type, content, options?){
        this.messageRef = this.nzMessageService.create(type, content, options);
        return this.messageRef;
    }
    
}